import * as React from "react";
import { Item } from "@/types/fse";
import { AddGroupModalContentStep2Row } from "./step2Row";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

interface Props {
  handleDelete: (item: Item) => void;
  selectedFiles: Item[];
  setSelectedFiles: React.Dispatch<React.SetStateAction<Item[]>>;
}

export const AddGroupModalContentStep2Dnd: React.FC<Props> = ({ setSelectedFiles, selectedFiles, handleDelete }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 0,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      setSelectedFiles(items => {
        const oldIndex = items.findIndex(item => item.id === active.id);
        const newIndex = items.findIndex(item => item.id === over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  return (
    <div className="mt-8">
      <div className="space-y-2 rounded-xl border border-gray-200 bg-gray-50 p-4">
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={selectedFiles.map(item => item.id)} strategy={verticalListSortingStrategy}>
            {selectedFiles.map(item => (
              <AddGroupModalContentStep2Row key={item.id} item={item} onDelete={handleDelete} />
            ))}
          </SortableContext>
        </DndContext>
      </div>
    </div>
  );
};
